/**
 * Created by Mark on 24/04/2017.
 */



import ApplicationServices from './base-service.js';
import Constants from '../constants/search.js';
import Action from '../actions/default.js';
import InternationalizationStore from '../store/internationalization-store.js';

class SearchService {

    searchLearning(searchTerm , language){
        return ApplicationServices.call(Constants.GET_VOCAB_TEXT_SEARCH , {fromLanguage:InternationalizationStore.locale , toLanguage:language , searchTerm:searchTerm}).then(function(response){
            return response;
        });
    }


    globalSearch(string){

        return ApplicationServices.call(Constants.GET_GLOBAL_TEXT_SEARCH , {searchString:string}).then(function(response){
            return response.results;
        });
    }

}

export default new SearchService();



// WEBPACK FOOTER //
// ./src/services/search-service.js